import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { loginSuppliesContactData } from "../../../../authentication/loginSuppliesContactData";

export type TemporaryStorageStepId =
  | "locationSelection"
  | "lockerSizeSelection"
  | "dateDurationSelection"
  | "personalData"
  | "bookingSummary";

/**
 * Centralized step counter for the Temporary Storage flow.
 * Adapts the total number of steps based on authentication method.
 * 
 * @remarks
 * - With EntraID auth: 4 steps (skips personal data)
 * - Without EntraID auth: 5 steps (includes personal data)
 */
export function useTemporaryStorageStepCounter(currentStep: TemporaryStorageStepId) {
  const tenantConfig = useSelector(
    (state: RootState) => state.tenantConfig.config
  );
  
  const hasEntraIdAuth = loginSuppliesContactData(tenantConfig?.authentication);

  const stepsWithPersonalData: TemporaryStorageStepId[] = [
    "locationSelection",
    "lockerSizeSelection",
    "dateDurationSelection",
    "personalData",
    "bookingSummary",
  ];
  
  const stepsWithoutPersonalData: TemporaryStorageStepId[] = [
    "locationSelection",
    "lockerSizeSelection",
    "dateDurationSelection",
    "bookingSummary",
  ];

  const steps = hasEntraIdAuth ? stepsWithoutPersonalData : stepsWithPersonalData;
  const index = Math.max(0, steps.indexOf(currentStep));
  const current = index + 1; // 1-based display
  const total = steps.length;

  return { current, total, hasEntraIdAuth };
}
